export interface Auth0UserInfo {
  sub: string;
  email: string;
  given_name: string;
  family_name: string;
  locale?: string;
}

export class AuthApi {
  static instance = new AuthApi();

  /**
   * Retrieves user information from Auth0 via the Laerdal ID SDK
   */
  retrieveAccountInfo = async (): Promise<Auth0UserInfo | null> => {
    try {
      const userInfo = await (window as any).laerdal?.auth?.getUserInfo();
      return userInfo ?? null;
    } catch {
      return null;
    }
  };

  /**
   * Checks if the user has a valid session
   */
  verifySession = async (): Promise<boolean> => {
    try {
      const auth = (window as any).laerdal?.auth;
      const provider = typeof auth?.get === 'function' ? auth.get('auth0') : auth;
      return await provider?.verifySession() ?? false;
    } catch {
      return false;
    }
  };

  /**
   * Checks if the user is authenticated
   */
  isAuthenticated = async (): Promise<boolean> => {
    try {
      return await (window as any).laerdal?.auth?.isAuthenticated() ?? false;
    } catch {
      return false;
    }
  };

  /**
   * Retrieves the access token from Auth0 via the Laerdal ID SDK.
   * @returns A JWT token for the currently authenticated user.
   */
  getToken = async (): Promise<string> => {
    try {
      const token = await (window as any).laerdal?.auth?.getToken();
      return token ?? '';
    } catch {
      return '';
    }
  };

  ClearCache = () => {
    // Token is managed by Auth0 SDK, no local cache to clear
  };
}

export default AuthApi.instance;